import script from "./TalkWithUs.vue?vue&type=script&setup=true&lang=js"
export * from "./TalkWithUs.vue?vue&type=script&setup=true&lang=js"

import "./TalkWithUs.vue?vue&type=style&index=0&id=4293c798&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4293c798"]])

export default __exports__